let $remote_item = $('.p-remote__item');

var $section1_top;
var $section2_top;

var remote_active = function(num){
    $remote_item.removeClass('p-remote__item--active');
    $remote_item.eq(num).addClass('p-remote__item--active');
};

$('.p-link').on('click',function (e) {
    e.preventDefault();
    $("html,body").stop().animate(
        {scrollTop: $($(this).attr('href')).offset().top + 'px'},
        {duration: 700}
    );
});

var compare = function(){
    var $curr_top = $(window).scrollTop();
    if($curr_top <= 56) $('.p-nav').css('top',56 - $curr_top+'px');
    else if($curr_top > 56) $('.p-nav').css('top', 0);

    if($curr_top < $section1_top - 100)
        remote_active(0);
    else if($curr_top < $section2_top - 100)
        remote_active(1);
    else
        remote_active(2);
    //$section2_top - $(window).height()/2 + 529)
};

$(window).scroll(function () {
    compare();
});

$(window).resize(function () {
    $section1_top = $('#section-1').offset().top;
    $section2_top = $('#section-2').offset().top;
    compare();
});

$('.p-nav__toggle').on('click',function () {
    if($(this).hasClass('hide')){
        $('.p-nav').animate({left: '0'});
        $('.p-nav__toggle').removeClass('hide');
    }
    else{
        $('.p-nav__toggle').addClass('hide');
        $('.p-nav').animate({left: '-300px'});
    }
});


// WEBPACK FOOTER //
// ./src/js/PC/remote.js